import { render, staticRenderFns } from "./datos-hijos.vue?vue&type=template&id=00aea163&scoped=true&"
import script from "./datos-hijos.ts?vue&type=script&lang=ts&"
export * from "./datos-hijos.ts?vue&type=script&lang=ts&"
import style0 from "./datos-hijos.vue?vue&type=style&index=0&id=00aea163&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00aea163",
  null
  
)

export default component.exports